import { ImageContainer } from "@/components/styles";
import Image from "@/components/ui/image";
import { templatePresets } from "@/constants/templates";
import useUserStore, { useIndexStore } from "@/state/user/useUserStore";
import React, { useState } from "react";

const MemeTemplate = ({ src, local }: { src: string; local?: boolean }) => {
  const [
    setRatio,
    setSelectedImage,
    setImageFormat,
    textFields,
    addTextField,
    restrictedFonts,
    setUploadAssets,
    setLocal,
    uploadAssets,
    assets,
  ] = useUserStore((state) => [
    state.setRatio,
    state.setSelectedImage,
    state.setImageFormat,
    state.textFields,
    state.addTextField,
    state.restrictedFonts,
    state.setUploadAssets,
    state.setLocal,
    state.uploadAssets,
    state.assets,
  ]);

  const [lastTextFieldIndex, setLastTextFieldIndex] = useIndexStore((state) => [
    state.lastTextFieldIndex,
    state.setLastTextFieldIndex,
  ]);

  const [aspectRatio, setAspectRatio] = useState<number>(1);

  const handleImageLoad = (event: React.SyntheticEvent<HTMLImageElement>) => {
    const loadedImage = event.target as HTMLImageElement;
    const aspectRatio = loadedImage.naturalWidth / loadedImage.naturalHeight;

    setAspectRatio(aspectRatio);
  };

  const allFieldsLength =
    textFields.length + uploadAssets.length + assets.length;

  const addTextFieldHandler = () => {
    if (
      templatePresets &&
      templatePresets.find((preset) => preset.src === src)
    ) {
      const preset = templatePresets.find((preset) => preset.src === src);
      if (preset) {
        preset.textFields.forEach((textField, index) => {
          const id = crypto.randomUUID();

          addTextField({
            id: id,
            text: "",
            font:
              restrictedFonts && restrictedFonts.length > 0
                ? restrictedFonts[0].value
                : "title1",
            fontSize: 44,
            startPosition: textField.startPosition,
            width: textField.width,
            zIndex: allFieldsLength + index + 1,
            index: lastTextFieldIndex + 1 + index,
          });
          setLastTextFieldIndex(lastTextFieldIndex + 1 + index);
        });
      }
    } else {
      const id = crypto.randomUUID();
      addTextField({
        id: id,
        text: "",
        font:
          restrictedFonts && restrictedFonts.length > 0
            ? restrictedFonts[0].value
            : "title1",
        fontSize: 44,
        zIndex: allFieldsLength + 1,
        index: lastTextFieldIndex + 1,
      });
      setLastTextFieldIndex(lastTextFieldIndex + 1);
    }
  };

  return (
    <ImageContainer
      whileHover={{
        scale: 1.02,
        transition: {
          duration: 0.15,
          ease: "linear",
        },
      }}
      whileTap={{ scale: 0.99 }}
      onClick={() => {
        setSelectedImage(src);
        setRatio(aspectRatio.toString());
        if (aspectRatio > 2) {
          setImageFormat("banner");
        } else {
          setImageFormat("post");
        }
        addTextFieldHandler();
        setUploadAssets([]);
        setLocal(local ?? false);
      }}
    >
      <Image
        src={src}
        alt=""
        fill
        onLoad={handleImageLoad}
        sizes="(max-width: 1200px) 30vw, 25vw"
        local={local}
      />

      {/* <
        draggable="false"
        src={src}
        style={{ objectFit: "cover" }}
        alt=""
        fill
        sizes="(max-width: 320px) 280px,
  (max-width: 480px) 440px,
  800px"
        onLoad={handleImageLoad}
      /> */}
    </ImageContainer>
  );
};

export default MemeTemplate;
